import React, { useState } from "react";
import "katex/dist/katex.min.css";
import Latex from "react-latex-next";
import Button from "../../components/common/Button";
import Div from "../../components/common/Div";
import { Tex } from "react-tex";
import {
  tenzero,
  NumberToLetter,
  fixOptions,
  fixMarginQuestionButtons,
} from "../../constants/Constants";
import Image from "../../components/common/Image";
import QuestionText from "../Partials/QuestionText";
import '../../pages/Admin/Styling.css'
import {formatLatexText} from "../../utils/formatLaTex";

export default function Q_MultipleChoice(props) {
  const [questionRerender, setQuestionRerender] = useState(false); //this is just used to rerender the page by toggling the arbitrary state

  const question = props.question;
  const type =
    question.options.length === 2 &&
    (question.options[0].text.toLowerCase() === "true" ||
      question.options[0].text.toLowerCase() === "false")
      ? "true/false"
      : "single";
  var options;
  const submission = props.submission;
  const questionNumber = props.questionNumber;
  const setSubmission = props.setSubmission;

  if (props.options === undefined) options = [];
  else options = props.options;

  function onSelected(e) {
    let submit = submission;
    submit[questionNumber] = e.target.innerHTML;
    setSubmission(submit);
    setQuestionRerender(!questionRerender);
  }

    function Options() {
        const hasImages = options.some((option) => option.url); // Check if any option contains an image

        return (
            <div className={`options-container ${hasImages ? "row-layout" : "column-layout"}`}>
                {options.map((option, i) => {
                    let formattedText = formatLatexText(option.text);
                    const letter = NumberToLetter(i);
                    return (
                        <div key={`option-${i}`} className="option-container">
                            <div className="option-text">
                                <span>{`${letter}. `}</span>

                                {formattedText && <Latex>{formattedText}</Latex>}
                            </div>
                            <div className="option-image">
                                {option.url && <Image src={option.url} width="150px" />}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }


    function TFButtons() {
    const trueHighlighted = submission[questionNumber] === "TRUE";
    const falseHighlighted = submission[questionNumber] === "FALSE";

    return (
      <Div padding={"0 10px"}>
        <Button
          margin={"0 10px"}
          key={"Button".concat("True")}
          onClick={onSelected}
          width={"40%"}
          height={"40px"}
          backgroundColor={
            trueHighlighted ? "rgba(16,44,79,0.4)" : "rgba(16,44,79,1)"
          }
          color={"#FFFFFF"}
          borderRadius={"5px"}
          fontWeight={"bold"}
        >
          TRUE
        </Button>
        <Button
          margin={"0 10px"}
          key={"Button".concat("False")}
          onClick={onSelected}
          width={"40%"}
          height={"40px"}
          backgroundColor={
            falseHighlighted ? "rgba(16,44,79,0.4)" : "rgba(16,44,79,1)"
          }
          color={"#FFFFFF"}
          borderRadius={"5px"}
          fontWeight={"bold"}
        >
          FALSE
        </Button>
      </Div>
    );
  }
  function SingleButtons() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);
      const value = MakeButton(letter, options.length);
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function MakeButton(text, numberOption) {
    const highlighted = submission[questionNumber] === text;

    const width = (window.innerWidth - numberOption * 2 * 3) / 2;
    const buttonWidth = width / numberOption;

    return (
      <Button
        key={"Button".concat(text)}
        onClick={onSelected}
        width={"60px"}
        height={"40px"}
        margin={"2px 3px"}
        backgroundColor={
          highlighted ? "rgba(16,44,79,0.4)" : "rgba(16,44,79,1)"
        }
        color={"#FFFFFF"}
        borderRadius={"5px"}
        fontWeight={"bold"}
      >
        {text}
      </Button>
    );
  }

  return (
    <Div height={"100%"} borderRadius={"1px"} width={"100%"}>
      <Div overflowY={"auto"} height={"80%"}>
        <QuestionText question={question}></QuestionText>
        <Image
          src={question.url}
          width="250px"
          style={{ display: "block", margin: "0 auto" }}
        />
        {type === "single" ? Options() : ""}
      </Div>
      <Div
        // margin={fixMarginQuestionButtons(options.length)}
        bottom={"0"}
        position={"relative"}
        width={"100%"}
      >
        {type === "single" ? SingleButtons() : TFButtons()}
      </Div>
    </Div>
  );
}
